@if (orderId; as orderId) {
  <ui-order-history-record [orderId]="orderId"></ui-order-history-record>
} @else {
  @if (queryParams(); as params) {
    <ui-order-history-overview
      [page]="params['page']"
      [limit]="params['limit']"
      [sort]="params['sort']"
      [orderFrom]="params['orderFrom']"
      [orderTo]="params['orderTo']"
      [shippingFrom]="params['shippingFrom']"
      [shippingTo]="params['shippingTo']"
      [delivery]="params['delivery']"
    ></ui-order-history-overview>
  }
}
